import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import { ICardElementWithChildren } from "backend/model/model";
import { t } from "i18next";
import React from "react";
import { BlueCard } from "./BlueCard";
import BlueChip from "../texts/BlueChip";
import HighChart from "../charts/Highchart";
import { PerformanceDonut } from "../charts/PerformanceDonut";
import PeriodChip from "../chips/PeriodChip";

const useKpiCardStyles = makeThemedStyles("KPICard", (theme) => ({
  root: {
    padding: "20px",
    width: "320px",
    minHeight: "330px",
    borderRadius: "4px",
    background:
      "linear-gradient(0deg, #E1F5FF 0%, rgba(225, 245, 255, 0) 100%)",
    color: "rgba(16, 41, 118, 1)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "12px",
  },
  actualTargetContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    gap: "20px",
    marginBottom: "20px",
  },
  actualTarget: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    gap: "5px",
  },
  title: {
    color: "rgba(16, 41, 118, 1)",
    fontWeight: "bold",
  },
  titleTypeName: {
    color: "rgba(16, 41, 118, 1)",
  },
  chartTitleStyle: {
    fontFamily: "Roboto, Helvetica",
    fontSize: "12px",
  },
  subTitle: {
    color: "rgba(16, 41, 118, 1)",
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: "center",
  },
}));

export const KpiCardTitle = (props: React.PropsWithChildren<{}>) => {
  const styles = useKpiCardStyles();
  return <div className={styles.title}>{props.children}</div>;
};

export const KpiCardTypeName = (props: React.PropsWithChildren<{}>) => {
  const styles = useKpiCardStyles();
  return <div className={styles.titleTypeName}>{props.children}</div>;
};

export const KPICard = React.memo(
  (
    props: React.PropsWithChildren<{
      element: ICardElementWithChildren;
      valueKey: keyof ICardElementWithChildren;
      colorKey: keyof ICardElementWithChildren;
      prettyKey: keyof ICardElementWithChildren;
      period: string;
      onSelect?: () => void;
      width?: string;
      height?: string;
      series?: Array<{
        title: string;
        series: keyof ICardElementWithChildren;
      }>;
    }>
  ) => {
    const styles = useKpiCardStyles();
    const { element: el, series } = props;

    return (
      <div
        className={styles.root}
        role="button"
        style={{
          cursor: props.onSelect ? "pointer" : undefined,
          width: props.width,
          minHeight: props.height,
        }}
        tabIndex={0}
        onKeyDown={() => {}}
        onClick={() => {
          if (props.onSelect) {
            props.onSelect();
          }
        }}
      >
        {props.children}
        <PeriodChip
          title={el.typename}
          period={el.period?.name || ""}
          icon="KPI"
        />

        <PerformanceDonut
          valueKey={props.valueKey}
          colorKey={props.colorKey}
          prettyKey={props.prettyKey}
          element={el}
          width={140}
          title="Score (YTD)"
        />

        <div className={styles.actualTargetContainer}>
          {series?.map((ser) => {
            return (
              <div className={styles.actualTarget} key={ser.title}>
                <div>{ser.title}</div>
                <div>{String(el[ser.series])}</div>
              </div>
            );
          })}
        </div>
        <div className={styles.subTitle}>{el.name}</div>
      </div>
    );
  }
);
